import { Stack } from '@mui/material';
import ListOfExpenseManagement from '../../../components/Escalations/ListOfExpenseManagement';
import VegaBreadCrumb from '../../../components/common/VegaBreadCrumb';
import VegaPageHeader from '../../../components/common/VegaPageHeader';
import { ROUTES } from '../../../router/routes';
import VegaButton from '../../../components/common/VegaButton';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { EscalationsServices } from '../../../Apis/EscalationsServices';
import { EscalationTriggerType } from '../../../types/request/escalationsRequest';
import { getErrorMessageFromErrorObj } from '../../../utils/api';

const ExpenseManagement = () => {
  const { setSnackbar } = useSnackbar();

  const triggerEscalation = () => {
    EscalationsServices.triggerEscalation({
      triggerType: EscalationTriggerType.EXPENSE,
    })
      .then(res => {})
      .catch(error => {
        setSnackbar(getErrorMessageFromErrorObj(error), 'error');
      });
  };
  return (
    <>
      <VegaPageHeader
        renderLeftView={() => {
          return (
            <Stack gap={1} width={'100%'}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <VegaBreadCrumb
                  items={[
                    { label: 'Escalation', link: ROUTES.ESCALATIONS },
                    { label: `Expense Management` },
                  ]}
                />
                <VegaButton
                  text="Trigger Escalation"
                  onClick={triggerEscalation}
                />
              </Stack>
            </Stack>
          );
        }}
      />
      <ListOfExpenseManagement />
    </>
  );
};

export default ExpenseManagement;
